import { css } from '@emotion/css';
import { Content } from '@volumental/common';
import React from 'react';
import { Header } from '../accessible-components';

const ImgContainer = css`
  width: 100%;
  text-align: center;
  position: relative;
  display: inline-block;
  height: auto;
  max-height: 360px;
`;
const headerContainer = css`
  position: absolute;
  top: 0px;
  width: 100%;
`;
const image = css`
  width: 100%;
  object-fit: cover;
  max-height: 360px;
`;

interface IntroProps {
  imgSrc: string;
  imgAlt: string;
  close: () => void;
}
function Intro({
  imgSrc,
  imgAlt,
  close,
  children,
}: React.PropsWithChildren<IntroProps>): React.JSX.Element {
  return (
    <Content disableGutters disableScrollbar>
      <div className={ImgContainer}>
        <img src={imgSrc} alt={imgAlt} className={image} />
        <div className={headerContainer}>
          <Header close={close} />
        </div>
      </div>
      {children}
    </Content>
  );
}

export default Intro;
